<script lang="ts">
  import { onMount } from 'svelte'
  import { api, type Category, type IpGroup, type HappRuleSet, type Target, type AuditEntry } from '../lib/api'
  import { fmtRelative } from '../lib/utils'
  import { formatEntity, formatAction, formatPayload } from '../lib/audit'

  let cats = $state<Category[]>([])
  let ipGroups = $state<IpGroup[]>([])
  let ruleSets = $state<HappRuleSet[]>([])
  let totalDomains = $state(0)
  let targets = $state<Target[]>([])
  let audit = $state<AuditEntry[]>([])

  onMount(async () => {
    const [c, ig, rs, d, t, a] = await Promise.all([
      api.listCategories(),
      api.listIpGroups(),
      api.listHappRuleSets(),
      api.listDomains({ limit: 1 }),
      api.listTargets(),
      api.listAudit(10)
    ])
    cats = c; ipGroups = ig; ruleSets = rs; totalDomains = d.total; targets = t; audit = a
  })

  let ipCount = $derived(ipGroups.reduce((s, g) => s + (g._count?.ipRanges || 0), 0))
  let tagCount = $derived(ruleSets.reduce((s, r) => s + (r._count?.tags || 0), 0))
  let activeFetches = $derived(
    targets.filter(t => t.lastFetchAt && (Date.now() - new Date(t.lastFetchAt).getTime()) < 86400000).length
  )
</script>

<div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 mb-6">
  {#each [
    ['Категорий', cats.length],
    ['Доменов', totalDomains],
    ['Групп IP', ipGroups.length],
    ['IP адресов', ipCount],
    ['Наборов Happ', ruleSets.length],
    ['Happ тегов', tagCount],
    ['Эндпоинтов', targets.length]
  ] as [label, value]}
    <div class="card p-3 sm:p-4">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-muted">{label}</div>
      <div class="text-xl sm:text-2xl font-bold mt-1">{value}</div>
    </div>
  {/each}
</div>

<div class="grid md:grid-cols-2 gap-4">
  <div class="card">
    <h2 class="text-sm font-semibold mb-3">Последние изменения</h2>
    <div class="space-y-2">
      {#each audit as a}
        <div class="flex gap-3 text-xs border-b border-bg-border/50 pb-2 last:border-0">
          <div class="text-muted whitespace-nowrap w-16 flex-shrink-0">{fmtRelative(a.createdAt)}</div>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-1 flex-wrap">
              <span class="font-medium">{a.username || '—'}</span>
              <span class="text-muted">{formatAction(a.action)}</span>
              <span>{formatEntity(a.entityType, a.entityId)}</span>
            </div>
            {#if formatPayload(a.payload)}
              <div class="text-muted text-[11px] mt-0.5 truncate" title={formatPayload(a.payload)}>
                {formatPayload(a.payload)}
              </div>
            {/if}
          </div>
        </div>
      {/each}
    </div>
  </div>

  <div class="card">
    <h2 class="text-sm font-semibold mb-3">Активность эндпоинтов</h2>
    <table class="tbl">
      <thead><tr><th>Название</th><th>Тип</th><th>Запросов</th><th>Последний</th></tr></thead>
      <tbody>
        {#each targets as t}
          <tr>
            <td class="font-medium">{t.name}</td>
            <td><span class="badge badge-blue">{t.type}</span></td>
            <td>{t.fetchCount}</td>
            <td class="text-muted">{fmtRelative(t.lastFetchAt)}</td>
          </tr>
        {/each}
        <tr>
          <td class="font-medium">Активных за 24ч</td>
          <td colspan="3" class="text-muted">{activeFetches}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
